// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#177878","successColor":"#1c4c50","infoColor":"#21abaa","warningColor":"#73787c","dangerColor":"#b18982"};